import TwilioComponent from "V2.0/HomePages/HomeIntegrations/TwilioComponent";
import { IntegrationShell } from "../common/Shell";
import { useOutletContext } from "react-router-dom";

export function TwilioIntegration() {
  const { projectId, thirdpartyData, updateThirdpartyData, isViewOnly } =
    useOutletContext();
  return (
    <IntegrationShell>
      <TwilioComponent
        projectId={projectId}
        twilioSettings={thirdpartyData.telephonySettings.twilioSettings}
        updateTwilioSettings={updateThirdpartyData}
        isViewOnly={isViewOnly}
      />
    </IntegrationShell>
  );
}
